<template>
  <div class="meiyu">
    <div class="top">
      <div class="topdate">{{date}}</div>
      <span class="title">柯桥</span>
      <div class="full" @click="buttonfull">
        <svg v-if="watchfull" class="icon" aria-hidden="true" style="color: #00dcfc;">
          <use xlink:href="#iconsuoxiaoquanping"></use>
        </svg>
        <svg v-else class="icon" aria-hidden="true" style="color: #00dcfc;">
          <use xlink:href="#iconquanping"></use>
        </svg>
      </div>
      <div class="back"
           @click="back" v-show="backitem">
        <img src="@/assets/meiyu/back.png"
             alt="">
        <span class="backdesc">返回</span>
      </div>
    </div>
    <div v-loading="loading" id="centermap" class="homepage-map">
      <img src="@/assets/homepage_img/legend.png" alt="">
      <div class="legend_cont">
        <div v-for="(item,index) in legendarr" :key="index">
          <img :src="require('@/assets/yl_icon/' + item.imgurl + '.png')" alt="">
          <span>{{item.desc}}</span>
        </div>
      </div>
    </div>
    <div class="left">
      <div class="realtimerain">
        <div class="contain">
          <div class="title">
            <div class="titlename">
              <div class="titlename_up">
                <span class="ssyq">天气预报</span>
              </div>
              <img src="@/assets/meiyu/titlebottom.png"
                   alt="">
            </div>
          </div>
          <div class="content">
            <div class="weather" v-loading="weatherloading"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.8)">
              <div class="todayweather">
                <img :src="cond_code" alt="">
                <span class="realtime"><span class="ssd">{{realtimetmp}}<span class="danwei">℃</span></span>{{cond_txt}}(实时)</span>
                <span class="jrqw">{{tmp_min}}-{{tmp_max}}℃</span>
                <span class="words" v-if="txt_d === txt_n">{{txt_d}}</span>
                <span class="words" v-else>{{txt_d}}转{{txt_n}}</span>
              </div>
              <div class="nextweather" v-for="(item,index) in nextweaarr" :key="index">
                <p v-if="index === 0">明天</p>
                <p v-else>{{weekday}}</p>
                <img :src="require('@/assets/weather/' + item.code_d + '.png')" alt="">
                <span>{{item.tmp_min}}-{{item.tmp_max}}℃</span>
                <span class="words" v-if="item.txt_d === item.txt_n">{{item.txt_d}}</span>
                <span class="words" v-else>{{item.txt_d}}转{{item.txt_n}}</span>
              </div>
            </div>
            <div class="rzdyl">
              <img src="@/assets/homepage_img/jyylzicon.png" alt="">
              <span class="words">日最大雨量</span>
              <span class="yl">25<span class="danwei">mm</span></span>
              <span class="xs">（ 10-15 8时 ）</span>
            </div>
          </div>
        </div>
      </div>
      <div class="realtimewater"
           ref="realtimewater">
        <div class="contain">
          <div class="title raintitle">
            <div class="titlename">
              <div class="titlename_up">
                <span class="sssq">实时水情</span>
                <div class="selected_time">
                  <span class="time_item"
                        :class="{'item_active':index==choosed1}"
                        v-for="(item, index) in selectedReservoirRiver"
                        :key="index"
                        @click="checkItem1(item, index)">
                    <span>{{ item.name }}</span>
                  </span>
                </div>
              </div>
              <img src="@/assets/meiyu/titlebottom.png" alt="">
            </div>
          </div>
          <div class="content">
            <el-table
              :data="tableData"
              v-if="this.tabName === '河道'"
              :max-height="tableheight"
              stripe
              style="width:100%;"
              @row-click="clickRow"
              :row-class-name="tableRowClassName">
              <el-table-column
                prop="stnm"
                label="站点名称"
                :min-width="minwidth">
              </el-table-column>
              <el-table-column
                align="right"
                prop="water_Str"
                label="水位"
                min-width="45">
              </el-table-column>
              <el-table-column
                align="right"
                prop="overflowWarningWater_Str"
                label="超警戒"
                min-width="51">
              </el-table-column>
              <el-table-column
                align="right"
                prop="overflowGuaranteeWater_Str"
                label="超保证"
                min-width="51">
              </el-table-column>
              <el-table-column
                header-align="center"
                align="right"
                prop="historyHighestWater_Str"
                label="历史最高"
                min-width="63">
              </el-table-column>
            </el-table>
            <el-table
              :data="tableData"
              v-if="this.tabName === '水库'"
              :max-height="tableheight"
              stripe
              style="width:100%;"
              @row-click="clickRow"
              :row-class-name="tableRowClassName1">
              <el-table-column
                prop="stnm"
                label="站点名称"
                :min-width="minwidth">
              </el-table-column>
              <el-table-column
                align="right"
                prop="water_Str"
                label="水位"
                min-width="45">
              </el-table-column>
              <el-table-column
                align="right"
                prop="warningWater_Str"
                label="汛限水位"
                min-width="51">
              </el-table-column>
              <el-table-column
                align="right"
                prop="overflowWarningWater_Str"
                label="超汛限"
                min-width="51">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <rainWaterProcess
      ref = "rainWater"
      :sTID="sTID"
      :waterDialogVisible.sync="waterDialogVisible"
    ></rainWaterProcess>
  </div>
</template>
<script>
import * as L from 'leaflet'
import screenfull from 'screenfull'
import monitorTypes from '@/store/types/monitor'
import meiyuTypes from '@/store/types/meiyu'
import homepageTypes from '@/store/types/homepage'
import request from '@/utils/request'
import rainWaterProcess from '@/views/nonfloodseason/RainWaterProcessing.vue'

require('@/assets/map/leaflet.ChineseTmsProviders.js')
var echarts = require('echarts')
export default {
  components: {
    rainWaterProcess
  },
  name: 'meiyu',
  data () {
    return {
      weatherloading: true,
      backitem: true,
      watchfull: '',
      isFullscreen: false,
      datev: '',
      allrain: '',
      watername: '',
      wateroverflow: '',
      aDDVCD: '330324',
      documentwidth: document.documentElement.clientWidth,
      meiyurain: [],
      tops: [],
      alldz: [],
      loading: true,
      loading1: true,
      loadingd: true,
      date: '',
      height: document.documentElement.clientHeight + 'px',
      tableheight: 10,
      superpolice: [],
      gates: [],
      tableData: [],
      selectedTime: [
        {
          name: '当日',
          value: '24h'

        }, {
          name: '前3小时',
          value: '3h'
        }, {
          name: '前1小时',
          value: '1h'
        }
      ],
      selectedReservoirRiver: [
        {
          name: '水库',
          value: 'reservoir'
        }, {
          name: '河道',
          value: 'river'
        }
      ],
      choosed: 2,
      choosed2: 2,
      choosed3: 2,
      chooseItem: '',
      chartnameAll: [],
      topsixvalueAll: [],
      choosed1: 1,
      gataData: [],
      minwidth: '75',
      moregate: [],
      yj: [],
      sID: '',
      sTID: '214',
      stationType: '2',
      waterFactor: '',
      maxHoldRainData: '',
      minHoldRainData: '',
      rivercoordinate: [],
      map: '',
      dialogVisible: false,
      therainchart: false,
      BeginTime: '2019-06-01',
      tabName: '河道',
      realtimetmp: '',
      cond_txt: '',
      cond_code: '',
      tmp_min: '',
      tmp_max: '',
      txt_d: '',
      txt_n: '',
      nextweaarr: [
        // { date: '明天', cond_code: require('@/assets/weather/101.png'), tmp_min: '12', tmp_max: '25', txt_d: '多云', txt_n: '晴' },
        // { date: '星期四', cond_code: require('@/assets/weather/101.png'), tmp_min: '12', tmp_max: '25', txt_d: '多云', txt_n: '晴' }
      ],
      weekday: '',
      today: '',
      beginTime: '',
      endTime: '',
      legendarr: [
        { imgurl: 'yl_0', desc: '=0mm' },
        { imgurl: 'yl_1', desc: '<30mm' },
        { imgurl: 'yl_2', desc: '30 - 50mm' },
        { imgurl: 'yl_3', desc: '50 - 80mm' },
        { imgurl: 'yl_4', desc: '80 - 100mm' },
        { imgurl: 'yl_5', desc: '100 - 250mm' },
        { imgurl: 'yl_6', desc: '>250' }
      ],
      waterDialogVisible: false
    }
  },
  methods: {
    // weekDay (date) {
    //   console.log(date.split('-')[0], date.split('-')[1] - 1, date.split('-')[2])
    //   var dt = new Date(date.split('-')[0], date.split('-')[1] - 1, date = date.split('-')[2])
    //   var weekDay = ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
    //   return weekDay[dt.getDay()]
    // },
    //  行选中
    clickRow (row) {
      // this.$refs.multipleTable1.toggleRowSelection(row)
      this.map.flyTo([row.lttd, row.lgtd], 18, {
        animate: true,
        duration: 1
      })
    },
    weatherdetail () {
      this.$axios.get('http://api.dayuteam.cn/weather/api/getWeather?code=CN101210506').then(res => {
        // 当天天气
        this.realtimetmp = res.data.tmp
        this.cond_txt = res.data.cond_txt
        this.cond_code = require('@/assets/weather/' + res.data.cond_code + '.png')
        this.tmp_min = res.data.forecastDays[0].tmp_min
        this.tmp_max = res.data.forecastDays[0].tmp_max
        this.txt_d = res.data.forecastDays[0].txt_d
        this.txt_n = res.data.forecastDays[0].txt_n
        // 明后天天气
        // let arr = res.data.forecastDays.slice(1, 3)
        this.nextweaarr = res.data.forecastDays.slice(1, 3)
        let week = this.nextweaarr[1].id.date_forecast
        var weekDay = ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
        var myDate = new Date(Date.parse(week))
        this.weekday = weekDay[myDate.getDay()]
        this.weatherloading = false
      })
    },
    choosetime () {
      this.choset = true
    },
    buttonfull () {
      if (!screenfull.enabled) {
        return false
      } else {
        screenfull.toggle()
      }
    },
    // 获取水库水位
    getHourlyRiverLevelData () {
      this.$store.dispatch(homepageTypes.GET_LATEST_WATER_LEVEL, {
        sID: this.sID,
        sTID: this.sTID,
        stationType: this.stationType,
        waterFactor: this.waterFactor
      }).then(data => {
        this.echartData = data.rows[0]
        this.maxHoldRainData = this.echartData.maxHoldRain
        this.minHoldRainData = this.echartData.minHoldRain
      })
    },
    back () {
      this.isFullscreen = true
      this.$nextTick(() => { this.$router.go(-1) })
    },
    drawChartAll (chartnameAll, topsixvalueAll) {
      let rainchartAll = this.$refs.rainchartAll
      let myChart = this.$echarts.init(rainchartAll)
      myChart.clear()
      myChart.setOption({
        title: {
          top: 5,
          textStyle: {
            // 文字颜色
            color: '#fff',
            // 字体风格,'normal','italic','oblique'
            fontStyle: 'normal',
            // 字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
            fontWeight: 'bold',
            // 字体系列
            fontFamily: 'sans-serif',
            // 字体大小
            fontSize: 13
          }
        },
        grid: {
          left: '0%',
          right: '0%',
          bottom: '5%',
          top: '30%',
          containLabel: true
        },
        tooltip: {},
        xAxis: [{
          type: 'category',
          data: chartnameAll,
          axisTick: {
            // alignWithLabel: true,
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            interval: 0,
            // rotate: 15,
            // 强制文字产生间隔
            textStyle: {// 文字样式
              color: '#fff',
              fontSize: 12,
              fontFamily: 'Microsoft YaHei'
            }
          }
        }],
        yAxis: [{
          type: 'value',
          axisTick: {
            show: false
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#02cae5'
            }
          },
          axisLabel: {
            formatter: function () {
              return ''
            }
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#fff'
            }
          }
        }],
        series: [{
          name: '雨量',
          type: 'bar',
          barWidth: '40%',
          data: topsixvalueAll,
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                offset: 0,
                color: '#00a2ff' // 0% 处的颜色
              }, {
                offset: 0.5,
                color: '#01bbef' // 60% 处的颜色
              }, {
                offset: 1,
                color: '#02cae5' // 100% 处的颜色
              }], false),
              label: {
                show: true,
                position: 'top',
                textStyle: {// 数值样式
                  color: '#02cae5',
                  fontSize: 16
                }
              }
            }
          }
        }]
      })
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.overflowWarningWater > 0 && row.overflowGuaranteeWater <= 0) { // 超警戒未超保证
        return 'warning-row'
      } else if (row.overflowGuaranteeWater > 0) {
        return 'success-row'
      }
      return ''
    },
    tableRowClassName1 ({ row, rowIndex }) {
      if (row.overflowWarningWater > 0) { // 超汛限
        return 'success-row'
      }
      return ''
    },
    getnowtime () {
      let thedate = new Date()
      let year = thedate.getFullYear()
      let month = thedate.getMonth() + 1
      let date = thedate.getDate()
      let hours = thedate.getHours()
      let minutes = thedate.getMinutes()
      let seconds = thedate.getSeconds()
      let weekend = thedate.getDay()
      switch (weekend) {
        case 1:
          weekend = '星期一'
          break
        case 2:
          weekend = '星期二'
          break
        case 3:
          weekend = '星期三'
          break
        case 4:
          weekend = '星期四'
          break
        case 5:
          weekend = '星期五'
          break
        case 6:
          weekend = '星期六'
          break
        case 0:
          weekend = '星期日'
          break
      }
      this.date = year + '年' + this.conver(month) + '月' + this.conver(date) + '日' + ' ' + weekend + ' ' + this.conver(hours) + ':' + this.conver(minutes) + ':' + this.conver(seconds)
    },
    conver (s) {
      return s < 10 ? '0' + s : s
    },
    leaflet (arr) {
      var imgm = L.tileLayer.chinaProvider('TianDiTu.Satellite.Map', {
        maxZoom: 18,
        minZoom: 10
      })
      var imga = L.tileLayer.chinaProvider('TianDiTu.Satellite.Annotion', {
        maxZoom: 18,
        minZoom: 10
      })
      var image = L.layerGroup([imgm, imga])
      let map = ''
      if (this.documentwidth <= 1400) {
        map = L.map('centermap', {
          center: [29.991, 120.569],
          zoom: 10,
          layers: [image],
          zoomControl: false
        })
      } else {
        map = L.map('centermap', {
          center: [29.991, 120.42],
          zoom: 11,
          layers: [image],
          zoomControl: false
        })
      }
      var myStyle = {
        'color': '#2dd9f8',
        'weight': 3,
        'opacity': 1
      }
      request.get('https://' + window.location.host + '/yjjson/yongjiaTown.json').then(res => {
        L.geoJSON(res.data, {
          style: myStyle
        }).addTo(map)
        this.drawBoundary(res.data.features[0].geometry.coordinates, map)
      })
      this.map = map
    },
    drawBoundary (blist, map) {
      // 画遮蔽层的相关方法
      // 思路: 首先在中国地图最外画一圈，圈住理论上所有的中国领土，然后再将每个闭合区域合并进来，并全部连到西北角。
      // 这样就做出了一个经过多次西北角的闭合多边形
      // 定义中国东南西北端点，作为第一层
      var pNW = { lat: 59.0, lng: 73.0 }
      var pNE = { lat: 59.0, lng: 136.0 }
      var pSE = { lat: 3.0, lng: 136.0 }
      var pSW = { lat: 3.0, lng: 73.0 }
      // 向数组中添加一次闭合多边形，并将西北角再加一次作为之后画闭合区域的起点
      var pArray = []
      pArray.push(pNW)
      pArray.push(pSW)
      pArray.push(pSE)
      pArray.push(pNE)
      pArray.push(pNW)
      // 循环添加各闭合区域
      for (var i = 0; i < blist.length; i++) {
        var points = []
        blist[i].forEach(item => {
          points.push({ lat: item[1], lng: item[0] })
        })
        // $.each(blist[i],function(k,v){
        //     points.push({lat:v[1],lng:v[0]})
        // })
        // 将闭合区域加到遮蔽层上，每次添加完后要再加一次西北角作为下次添加的起点和最后一次的终点
        pArray = pArray.concat(points)
        pArray.push(pArray[0])
      }
      // 添加遮蔽层
      var plyall = L.polygon(pArray, { color: 'transparent', fillColor: '#242422', fillOpacity: 0.8 }) // 建立多边形覆盖物
      plyall.addTo(map)
    },
    openDialogStation () {
      this.dialogStation = true
      this.checkItem3(this.chooseItem, this.choosed)
    },
    openAllrainDialog () {
      this.dialogVisible = true
      this.checkItem2(this.chooseItem, this.choosed)
    },
    // 公共雨情信息接口调用
    commonRaininfo (type, item) {
      this.$store.dispatch(meiyuTypes.GET_TOWN_RAIN, {
        aDDVCD: this.aDDVCD,
        type: item.value,
        townOrderField: 'Rain',
        stationOrderField: ''
      }).then(data => {
        let detailarr = data.townData
        let chartnameAll = []
        let topsixvalueAll = []
        detailarr.forEach(item => {
          chartnameAll.push(item.addvcd)
          topsixvalueAll.push(item.rain)
        })
        if (type === 'qqmyl') {
          this.drawChartAll(chartnameAll, topsixvalueAll)
        } else {
          this.chartnameAll = chartnameAll
          this.topsixvalueAll = topsixvalueAll
        }
        this.alldz = data.stationData
        this.loading = false
      })
    },
    // 实时水情点击切换
    checkItem1 (item, index) {
      this.choosed1 = index
      if (this.choosed1 === 0) {
        this.reservoirwater()
      } else {
        this.riverwater()
      }
    },
    // 河道水情
    riverwater () {
      this.minwidth = '87'
      this.tabName = '河道'
      this.watername = '超保证'
      this.wateroverflow = 'overflowWarningWater'
      this.$store.dispatch(monitorTypes.GET_STATISTICS_RIVER_WATER, {
        aDDVCD: this.aDDVCD,
        stationName: '',
        orderField: this.wateroverflow,
        desc: true
      }).then(data => {
        this.tableData = data.rows
        this.loading = false
        this.drawPoint(this.tableData)
      })
    },
    // 水库水情
    reservoirwater () {
      this.minwidth = '75'
      this.tabName = '水库'
      this.watername = '超汛限'
      this.wateroverflow = 'overflowWarningWater'
      this.$store.dispatch(monitorTypes.GET_STATISTICS_RESERVOIR_WATER, {
        aDDVCD: this.aDDVCD,
        stationName: this.stationName,
        orderField: this.wateroverflow,
        desc: true
      }).then(data => {
        this.tableData = data.rows
        this.loading = false
      })
    },
    // 水库打点
    reservoirpointer () {
      // this.minwidth = '75'
      // this.tabName = '水库'
      // this.watername = '超汛限'
      // this.wateroverflow = 'overflowWarningWater'
      this.$store.dispatch(monitorTypes.GET_STATISTICS_RESERVOIR_WATER, {
        aDDVCD: this.aDDVCD
        // stationName: this.stationName,
        // orderField: this.wateroverflow,
        // desc: true
      }).then(data => {
        this.drawPoint(data.rows)
      })
    },
    seasonRainfall () {
      this.loadingd = true
      this.$store.dispatch(meiyuTypes.GET_RAINLY_SEASON_RAINFALL, { aDDVCD: this.aDDVCD, beginTime: this.BeginTime }).then(data => {
        this.meiyurain.push({ name: '梅雨期面雨量', value: data.data.rain })
        this.meiyurain.push({ name: '常年同期', value: data.data.lastYearRian })
        this.meiyurain.push({ name: '同比', value: data.data.accRate })
        this.loadingd = false
      })
    },
    // 地图上添加标记点
    drawPoint (arr) {
      var that = this
      arr.forEach(item => {
        var myIcon = L.icon({
          iconUrl: require('@/assets/homepage_img/swicon.png'),
          iconAnchor: [8, 8]
        })
        let markers = L.marker([item.lttd, item.lgtd], { icon: myIcon, title: item.adcdName }).addTo(this.map)
        markers.bindTooltip('<b>' + item.stnm + '</b>', {
          parmanent: true,
          sticky: true,
          className: 'anim-tooltip'
        })
        markers.on('click', function () {
          that.sTID = item.stid
          that.$refs['rainWater'].stationchart()
          that.waterDialogVisible = true
        })
      })
      this.loading = false
    },
    gettime: function () {
      let date = new Date()
      let month = date.getMonth() + 1
      if (date.getHours() >= 8) {
        this.beginTime = date.getFullYear() + '-' + month + '-' + date.getDate() + ' 08:00'
        this.endTime = date.getFullYear() + '-' + month + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes()
      } else {
        let day = date.getDate() - 1
        this.beginTime = date.getFullYear() + '-' + month + '-' + day + ' ' + date.getHours() + ':' + date.getMinutes()
        this.endTime = date.getFullYear() + '-' + month + '-' + date.getDate() + ' 08:00'
      }
    },
    // 雨量
    tabledata () {
      console.log(this.beginTime, this.endTime)
      this.$store.dispatch(monitorTypes.GET_STATISTICS_RAIN, {
        aDDVCD: this.aDDVCD,
        appType: this.appType,
        beginTime: this.beginTime,
        endTime: this.endTime
      }).then(data => {
        console.log(data.rows, 333)
        this.drawylPoint(data.rows)
      })
    },
    // 地图上添加标记点
    drawylPoint (arr) {
      let myIcon
      arr.forEach(item => {
        if (item.rainToday === 0) {
          myIcon = L.icon({
            iconUrl: require('@/assets/yl_icon/yl_0.png'),
            iconAnchor: [8, 8]
          })
        } else if (item.rainToday < 30) {
          myIcon = L.icon({
            iconUrl: require('@/assets/yl_icon/yl_1.png'),
            iconAnchor: [8, 8]
          })
        } else if (item.rainToday > 30 && item.rainToday < 50) {
          myIcon = L.icon({
            iconUrl: require('@/assets/yl_icon/yl_2.png'),
            iconAnchor: [8, 8]
          })
        } else if (item.rainToday > 50 && item.rainToday < 80) {
          myIcon = L.icon({
            iconUrl: require('@/assets/yl_icon/yl_3.png'),
            iconAnchor: [8, 8]
          })
        } else if (item.rainToday > 80 && item.rainToday < 100) {
          myIcon = L.icon({
            iconUrl: require('@/assets/yl_icon/yl_4.png'),
            iconAnchor: [8, 8]
          })
        } else if (item.rainToday > 100 && item.rainToday < 250) {
          myIcon = L.icon({
            iconUrl: require('@/assets/yl_icon/yl_5.png'),
            iconAnchor: [8, 8]
          })
        } else {
          myIcon = L.icon({
            iconUrl: require('@/assets/yl_icon/yl_6.png'),
            iconAnchor: [8, 8]
          })
        }
        let markers = L.marker([item.lttd, item.lgtd], { icon: myIcon, title: item.adcdName }).addTo(this.map)
        markers.bindTooltip('<b>' + item.stnm + '</b>', {
          parmanent: true,
          sticky: true,
          className: 'anim-tooltip'
        })
      })
      this.loading = false
    }
  },
  created () {
    // this.$nextTick(() => {
    //   this.checkItem(this.selectedTime[2], 2)
    // })
  },
  mounted () {
    this.gettime()
    this.tabledata()
    this.weatherdetail()
    this.reservoirpointer()
    window.onresize = () => {
      this.watchfull = screenfull.isFullscreen
      if (this.watchfull) {
        this.backitem = false
      } else {
        this.backitem = true
      }
    }
    let _this = this // 声明一个变量指向Vue实例this，保证作用域一致
    this.timer = setInterval(() => {
      _this.getnowtime()
    }, 1000)
    this.$nextTick(() => {
      this.leaflet()
    })
    this.getnowtime()
    this.riverwater()
    this.seasonRainfall()
    this.loading = false
    this.getHourlyRiverLevelData()
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('raintitle')
      let rainDiv = document.getElementsByClassName('realtimewater')
      this.tableheight = rainDiv[0].offsetHeight - contentDiv[0].offsetHeight - 30
    })
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer) // 在Vue实例销毁前，清除我们的定时器
    }
  }
}
</script>
<style>
.select-option {
  z-index: 9999 !important;
  border: 1px solid #00f0ff;
  background-color: #060a22;
}
.select-option .el-select-dropdown__item {
  background-color: #060a22;
  color: #ffffff;
}
.select-option .el-select-dropdown__item.hover,
.select-option .el-select-dropdown__item:hover {
  background-color: #10173e;
}
</style>

<style lang="less" scoped>
@import url("../../assets/map/leaflet.css");
.centerMapContent {
  width: 100%;
  height: 1080px;
  position: relative;
}
#centermap {
  width: 100%;
  height: 1080px;
  position: relative;
}
#centermap> img{
  position: absolute;
  z-index: 999;
  left: 570px;
  top: 700px;
  width: 155px;
  height: 234px;
}
#centermap>.legend_cont{
  width: 130px;
  height: 190px;
  position: relative;
  z-index: 999;
  left: 590px;
  top: 730px;
}
#centermap>.legend_cont>div{
  height: 18px;
  line-height: 18px;
  margin-top: 10px;
  // position: absolute;
}
#centermap>.legend_cont span{
  color: #fff;
  margin-left: 15px;
}
#centermap>.legend_cont img{
  position: relative;
  top: 2px;
}
@media screen and (min-height:1100px){
  .centerMapContent {
    width: 100%;
    height: 100%;
    position: relative;
  }
  #centermap {
    width: 100%;
    height: 100%;
    position: relative;
  }
}
.mapboxgl-control-container {
  display: none;
}
.el-row {
  margin-bottom: 20px;
}
.el-row:last-child {
  margin-bottom: 0;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  /* background:rgba(162,44,25,.6); */
  background-image: url(~@/assets/meiyu/chaojin.png);
  background-repeat: no-repeat;
  background-size: 141px 87px;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  /* min-height: 36px; */
  height: 87px;
  /* height: 100%; */
}
#chartall,#danzhan,#zhazhan{
  z-index: 9999999 !important;
}
 .rainchartAll {
  width: 1000px;
  height: 280px;
  margin: 50px auto 0 auto;
}
.row-bg {
  padding: 10px 0;
  position: absolute;
  width: 850px;
  height: 85px;
  left: 50%;
  margin-left: -425px;
  top: 85px;
  z-index: 9999;
}
.warn-name {
  width: 100%;
  height: 20px;
  font-size: 16px;
  text-align: center;
  color: #fff;
  margin: 0;
  padding: 15px 0;
}
.warn-num {
  width: 100%;
  height: 20px;
  text-align: center;
  color: #ffff00;
  font-size: 30px;
  margin: 0;
  padding: 5px 0;
  font-style: italic;
  font-weight: 900;
}
.warn-num > span {
  font-size: 16px;
  color: #fff;
  margin-left: 10px;
}
</style>
<style lang="less" scoped>
.meiyu {
  // background: #21251f;
  height: 100%;
  position: relative;
  .el-dialog{
    .topthree {
      // display: inline-block;
      height: 70px;
      // justify-content: space-between;
      // display: flex;
      .topitem {
        // margin-top: 25px;
        position: relative;
        display: inline-block;
        color:#fff;
        width: 117px;
        margin-left: 45px;
        margin-top: 25px;
        img {
          width: 117px;
          height: 71px;
        }
        .topdesc {
          font-size: 14px;
          position: absolute;
          top: 11px;
          left: 25px;
          width: 100px;
          left: 50%;
          margin-left: -50px;
          height: 15px;
          text-align: center;
        }
        .val {
          .topdesc;
          top: 35px;
          left: 45px;
          font-size: 24px;
          text-align: center;
          font-style: italic;
          font-weight: 500;
          .danwei {
            font-size: 14px;
            position: absolute;
            top: 10px;
          }
        }
      }
    }
    .title {
      height: 33px;
      position: relative;
      margin-top: -8px;
      .titlename {
        height: 33px;
        position: relative;
        /deep/ .titlename_select {
          position: absolute;
          top: -13px;
          .el-input--suffix {
            .el-input__inner {
              width: 160px;
              background: #060a22;
              border: none;
              color: #ffffff;
              font-size: 18px;
            }
          }
        }
        .button {
          position: relative;
          display: inline-block;
          padding: 0.5rem 1rem;
          background: transparent;
          color: white;
          text-transform: uppercase;
          text-decoration: none;
          font: bold 200%/1 sans-serif;
          &::before {
            content: "";
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 0;
            background: #fff;
            transform: skew(45deg);
          }
        }
        .titlename_span {
          font-size: 18px;
          color: #fff;
          position: absolute;
          top: 0;
        }
        .titlename_up {
          width: 100%;
          height: 100%;
          span.ssyq,
          span.sssq {
            width: 20%;
            font-size: 18px;
            display: block;
            float: left;
            color: #fff;
          }
          .selected_time {
            width: 80%;
            height: 100%;
            float: right;
            .time_item {
              cursor: pointer;
              height: 30px;
              float: right;
              padding: 0 7px;
              line-height: 26px;
              display: block;
              font-size: 14px;
              color: #ffffff;
              border: 1px solid #079eb6;
              transform: skewX(-30deg);
              span {
                display: block;
                transform: skewX(30deg);
              }
            }
            .item_active {
              background: #064961;
            }
          }
        }
        img {
          width: 100%;
          height: 7px;
          position: absolute;
          top: 27px;
        }
      }
    }
  }
  .top {
    background-image: url("~@/assets/meiyu/top.png");
    background-repeat: no-repeat;
    background-size: 100% 200%;
    height: 77px;
    width: 100%;
    text-align: center;
    position: absolute;
    z-index: 99999;
    .topdate {
      color: #fefefe;
      font-size: 15px;
      position: absolute;
      top: 15px;
      left: 65px;
    }
    .title {
      margin-top: 23px;
      font-size: 32px;
      color: #00f0ff;
      font-weight: bold;
      display: inline-block;
    }
    .person {
      color: #fefefe;
      font-size: 15px;
      position: absolute;
      top: 15px;
      right: 90px;
      .dbld {
        span {
          color: #fec307;
        }
      }
      .zbry {
        .dbld;
        margin-left: 30px;
      }
    }
    .back {
      position: absolute;
      cursor: pointer;
      right: 15px;
      top: 8px;
      width: 70px;
      img {
        width: 26px;
        height: 24px;
      }
      .backdesc {
        color: #00dcfc;
        font-size: 15px;
        line-height: 15px;
        display: inline-block;
        vertical-align: middle;
        margin-top: -8px;
        margin-left: 5px;
      }
    }
    .full{
      .back;
      right: 75px;
    }
  }
  .left {
    width: 430px;
    height: 850px;
    position: absolute;
    // background: #fec307;
    top: 75px;
    bottom: 40px;
    left: 50px;
    z-index: 9999;
    .realtimerain {
      width: 100%;
      height: 350px;
      margin-top: 10px;
      background: #060a22;
      // box-shadow: 0 0 5px #283955 inset;
      box-shadow: 0 0 12px #253578;
      padding: 15px 27px;
      .contain {
        width: 380px;
        height: 390px;
        // background: #fec307;
        .title {
          height: 33px;
          .titlename {
            height: 33px;
            position: relative;
            /deep/ .titlename_select {
              position: absolute;
              top: -13px;
              .el-input--suffix {
                .el-input__inner {
                  width: 160px;
                  background: #060a22;
                  border: none;
                  color: #ffffff;
                  font-size: 18px;
                }
              }
            }
            .button {
              position: relative;
              display: inline-block;
              padding: 0.5rem 1rem;
              background: transparent;
              color: white;
              text-transform: uppercase;
              text-decoration: none;
              font: bold 200%/1 sans-serif;
              &::before {
                content: "";
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                z-index: 0;
                background: #fff;
                transform: skew(45deg);
              }
            }
            .titlename_span {
              font-size: 18px;
              color: #fff;
              position: absolute;
              top: 0;
            }
            .titlename_up {
              width: 100%;
              height: 100%;
              span.ssyq,
              span.sssq {
                width: 20%;
                font-size: 18px;
                display: block;
                float: left;
                color: #fff;
              }
              .selected_time {
                width: 80%;
                height: 100%;
                float: right;
                .time_item {
                  cursor: pointer;
                  height: 30px;
                  float: right;
                  padding: 0 7px;
                  line-height: 26px;
                  display: block;
                  font-size: 14px;
                  color: #ffffff;
                  border: 1px solid #079eb6;
                  transform: skewX(-30deg);
                  span {
                    display: block;
                    transform: skewX(30deg);
                  }
                }
                .item_active {
                  background: #064961;
                }
              }
            }
            img {
              width: 380px;
              height: 7px;
              position: absolute;
              top: 27px;
            }
          }
        }
        .content {
          margin-top: 10px;
          // width: 430px;
          .weather{
            height: 176px;
            // width: 430px;
            // background: #00deff;
            .todayweather{
              width: 135px;
              height: 176px;
              // background: #00deff;
              // display: inline-block;
              float: left;
              text-align: center;
              img{
                width: 60px;
                // margin-top: 30px;
                // margin-bottom: 5px;
              }
              span{
                margin-top: 8px;
                display: block;
                font-size: 16px;
                color: #fff;
              }
              .ssd{
                font-size: 28px;
                display: inline-block;
                margin-right: 7px;
                .danwei{
                  display: inline-block;
                  font-size: 14px;
                }
              }
            }
            .nextweather{
              width: 110px;
              height: 176px;
              background-color: #0a1f46;
              display: inline-block;
              margin-left: 10px;
              text-align: center;
              color: #fff;
              font-size: 15px;
              p{
                font-size: 15px;
              }
              img{
                width: 50px;
                margin-top: 10px;
                margin-bottom: 10px;
              }
              span{
                display: block;
                margin-top: 3px;
              }
            }
          }
          .rzdyl{
            height: 75px;
            margin-top: 25px;
            img{
              width: 383px;
              height: 72px;
              position: absolute;
            }
            .words{
              color: #fff;
              font-size: 16px;
              margin-left: 77px;
              line-height: 72px;
              // position: relative;
            }
            .yl{
              font-size: 28px;
              color: #00f0ff;
              margin-left: 15px;
              font-style: italic;
              .danwei{
                font-size: 16px;
              }
            }
            .xs{
              margin-left: 15px;
              color: #fff;
              font-size: 16px;
            }
          }
        }
      }
    }
    .realtimewater {
      .realtimerain;
      margin-top: 10px;
      height: 620px;
      padding: 15px 0;
      .contain {
        height: 290px;
        width: 405px;
        .title {
          margin-left: 27px;
        }
        .content {
          margin-top: 10px;
          width: 430px;
        }
      }
    }
  }
}
.meiyu /deep/ .el-dialog {
  z-index: 9999999;
  background-color: #060a22;
  margin-top: 22vh !important;
  width: 47%;
  // height: 50%
  .el-dialog__body {
    padding-top: 10px;
    overflow: auto;
    height: 400px;
  }
  .el-dialog__title {
    color: #fff;
  }
  .el-dialog__close {
    color: #fff;
  }
}
.meiyu /deep/ #choset .el-dialog{
 width: 500px;
 height: 200px;
}
.el-dialog {
  background-color: #060a22;
  .gateitem {
    margin-top: 17px;
    width: 100%;
    // height: 100px;
    border: 1px solid #1a3a6c;
    .gatetop {
      height: 35px;
      line-height: 35px;
      background: #0f3164;
      .name {
        font-size: 15px;
        color: #fff;
        float: left;
        margin-left: 17px;
      }
      .time {
        color: #fff;
        font-size: 14px;
        float: right;
        margin-right: 10px;
      }
      .desc {
        font-size: 14px;
        color: #00deff;
        float: right;
        margin-right: 17px;
      }
    }
    .gateicons {
      margin-top: 6px;
      .gateicon {
        margin-left: 17px;
        height: 55px;
        position: relative;
        margin-top: 5px;
        // margin-bottom: 5px;
        text-align: center;
        width: 22px;
        height: 38px;
        img {
          width: 22px;
          height: 38px;
        }
        span {
          color: #fff;
          font-size: 14px;
          display: block;
        }
      }
    }
  }
}
.meiyu /deep/ .el-table tr {
  // text-align: center;
  color: #fff;
  background: #060a22;
}
.meiyu /deep/ .el-table tr.el-table__row--striped td {
  background: #061737;
}
.meiyu /deep/ .content .el-table .warning-row td{
  background: #b7b71f !important;
}
.meiyu /deep/ .content .el-table .success-row{
  background:#dc3217;
}
.meiyu /deep/ .el-table td {
  // text-align: center;
  padding: 5px 0;
  border: none;
}
.meiyu /deep/ .el-table th.is-leaf {
  border: none;
}
.meiyu /deep/ .el-table th {
  // text-align: center;
  color: #00deff;
  background: #060a22;
}
.meiyu /deep/ .el-table__body tr:hover > td {
  background: #072447;
}
.meiyu /deep/ .el-table::before {
  background: #060a22;
}
.meiyu /deep/ *::-webkit-scrollbar {
  width: 0.25rem;
  height: 0.25rem;
  background-color: #072351;
}
.meiyu /deep/ *::-webkit-scrollbar-track {
  border-radius: 0.1rem;
  background-color: #06214e;
}
.meiyu /deep/ *::-webkit-scrollbar-thumb {
  /*width: 0.1rem;
     */
  height: 0.2rem;
  border-radius: 0.1rem;
  background-color: #0c3974;
}
.meiyu /deep/ .el-table__header {
  table-layout: auto;
  border-collapse: separate;
}
.meiyu /deep/ .el-table__body-wrapper,
.meiyu /deep/ .is-scrolling-none,
.el-table {
  background: #060a22;
}
</style>
